module.exports = __webpack_public_path__ + "img/character_off.de1da0a2.png";